import { Box, GlobalStyles, Sheet, Stack, Tabs } from "@mui/joy";
import { useMediaQuery, useTheme } from "@mui/material";
import { useRecoilValue } from "recoil";
import { userAtom } from "recoil/userAtom";
import SidebarToggleButton from "./SideBarToggleButton";
import WidthControlButton from "./WidthControlButton";
import { layoutAtom } from "recoil/layoutAtom";
import TaskTabs from "components/task/TaskTabs";
import { taskSectionAtom, TaskSectionType } from "recoil/taskSectionAtom";
import { patientAtom } from "recoil/patientAtom";
import { useLocation } from "react-router-dom";

export default function Header() {
  const patientState = useRecoilValue(patientAtom);
  const user = useRecoilValue(userAtom);
  const isCoach = user?.accessToken && user?.role !== "patient";
  const theme = useTheme();

  const isBigScreen = useMediaQuery(theme.breakpoints.up("md"));
  const isHome = window.location.pathname === "/";

  const { isLeftSideBarOpen, isRightSideBarOpen } = useRecoilValue(layoutAtom);
  const taskSectionState = useRecoilValue(taskSectionAtom);

  const { state } = useLocation();
  const isOnboarding = state?.isOnboarding || false;

  const isTransparent = window.location.pathname === "/payment/management";

  return (
    (user?.accessToken || isOnboarding) && (
      <Sheet
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          top: 0,
          width: "100vw",
          height: "var(--Header-height)",
          ...(!isTransparent
            ? {
                borderBottom: 1,
                borderColor: "background.level3",
                backgroundColor: "background.level3",
              }
            : {
                backgroundColor: "transparent",
              }),
        }}
      >
        <GlobalStyles
          styles={(theme) => ({
            ":root": {
              "--Header-height": "34px",
              "--joy-palette-primary-outlinedColor":
                theme.vars.palette.primary.solid,
              "--joy-palette-primary-outlinedBorder":
                theme.vars.palette.primary.solid,
            },
          })}
        />
        {isHome && (
          <Stack
            direction={"row"}
            alignItems="center"
            display={"flex"}
            sx={{
              backgroundColor: "background.level3",
              zIndex: 100,
              pl: 2,
              gap: 1,
              position: {
                xs: "fixed",
                lg: !isLeftSideBarOpen ? "fixed" : "sticky",
              },
              left: 0,
              width: isLeftSideBarOpen ? "var(--Sidebar-width)" : "64px",
              height: "var(--Header-height)",
              overflow: "hidden",
              transition: " width 0.2s",
            }}
          >
            <SidebarToggleButton />
          </Stack>
        )}
        {isHome && (
          <Stack
            sx={{
              position: "relative",
              flex: 1,
              backgroundColor: "background.level3",
              display: "flex",
              flexDirection: "row",
              width: "100%",
              minWidth: 0,
              height: "100%",
              transition: "transform 0.4s, width 0.4s",
              pr:
                isCoach &&
                !isRightSideBarOpen &&
                (taskSectionState || []).length === 1
                  ? "64px"
                  : 0,
            }}
          >
            {taskSectionState &&
              taskSectionState.map((each: TaskSectionType, index: number) => (
                <Tabs
                  key={`section${index}`}
                  aria-label={`Basic tabs_${index}`}
                  sx={{
                    flex: 1,
                    flexShrink: 0,
                    minWidth: 0,
                    width: "100%",
                    height: "var(--Header-height)",
                    position: "flex",
                    flexDirection: "row",
                  }}
                  value={(taskSectionState || [])[index].currentTaskKey}
                >
                  <TaskTabs index={index} />
                </Tabs>
              ))}
            {isBigScreen && (taskSectionState || []).length === 1 && (
              <Box
                sx={{
                  width: "64px",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <WidthControlButton />
              </Box>
            )}
          </Stack>
        )}
        {isCoach && patientState?.patientId && (
          <Stack
            direction={"row-reverse"}
            alignItems="center"
            display={"flex"}
            sx={{
              backgroundColor: "background.level3",
              zIndex: 100,
              px: 2,
              gap: 1,
              right: 0,
              position: {
                xs: "fixed",
                lg: !isRightSideBarOpen ? "fixed" : "sticky",
              },
              width: isRightSideBarOpen ? "var(--InsideC-width)" : "64px",
              height: "var(--Header-height)",
              transition: "transform 0.4s, width 0.4s",
            }}
          >
            <SidebarToggleButton direction="right" />
          </Stack>
        )}
      </Sheet>
    )
  );
}
